(() => {
  const back = document.querySelector('[data-mobile-back]');
  if (back && document.referrer) {
    const previous = new URL(document.referrer);
    if (previous.origin === window.location.origin && window.history.length > 1) {
      back.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        window.history.back();
      });
    }
  }

  // Cart edits submit full-page forms; refresh cached counts when returning with Back.
  window.addEventListener('pageshow', async (event) => {
    if (!event.persisted) return;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((counter) => {
        counter.textContent = cart.item_count;
      });
    } catch (error) {
      console.warn('Unable to refresh cart count.', error);
    }
  });
})();
